import { Badge } from '../../ui/badge';

export default function EquipmentTypeBadge({ type }: { type: string }) {
    return (
        <Badge className="shrink-0 text-xs font-medium border-foreground/25 bg-foreground/[0.08] text-foreground hover:bg-foreground/[0.08]">
            {type}
        </Badge>
    );
}
